export const newsList = [
  {
    id: 1,
    title: "大岛优香主演新剧《春日信笺》定档，首曝剧照引期待",
    summary:
      "由大岛优香领衔主演的都市情感剧《春日信笺》正式宣布定档，官方同步释出首组人物剧照，温婉气质与细腻演绎引发观众热烈讨论。",
    category: "最新动态",
    date: "2026-09-28",
    author: "本站编辑部",
    source: "大岛优香官方资讯",
    views: 12860,
    image:
      "https://readdy.ai/api/search-image?query=warm%20spring%20daylight%20soft%20blurred%20background%20with%20delicate%20letter%20paper%20and%20pink%20cherry%20blossom%20petals%2C%20editorial%20still%20life%20photography%2C%20gentle%20orange%20tone%2C%20minimal%20clean%20composition&width=800&height=600&seq=yn-news-01&orientation=landscape",
    content: [
      "备受期待的都市情感剧《春日信笺》于近日正式官宣定档，大岛优香将在剧中饰演一位在快节奏城市中坚持手写信件的图书编辑。剧组同步公开了首组人物海报与剧照，画面中她以简约针织造型出镜，气质温婉而坚定。",
      "据制作方透露，《春日信笺》以「书信」为线索，串联起三段关于选择与告别的故事。大岛优香所饰演的角色需要在理想与现实之间反复权衡，人物弧光细腻，是全剧的情感核心。",
      "在谈到角色时，大岛优香表示，为了贴近人物的生活状态，她提前一个月体验了图书编辑的日常，并坚持手写剧中出现的每一封信。「手写的时候，笔尖的停顿本身就是情绪，这对我塑造角色帮助很大。」",
      "该剧预计将于今年冬季与观众见面，届时将在主流平台同步上线。官方后续还将陆续发布主题曲与幕后花絮，本站将持续跟进报道。",
    ],
  },
  {
    id: 2,
    title: "大岛优香亮相国际电影节红毯，一袭香槟礼服惊艳全场",
    summary:
      "在刚刚落幕的国际电影节开幕红毯上，大岛优香以一身香槟色缎面礼服优雅现身，从容的台风与高级的造型成为当晚媒体镜头的焦点之一。",
    category: "活动预告",
    date: "2026-09-21",
    author: "特约记者 林薇",
    source: "国际电影节官方",
    views: 20341,
    image:
      "https://readdy.ai/api/search-image?query=elegant%20champagne%20colored%20satin%20fabric%20drape%20texture%20close%20up%20with%20soft%20golden%20stage%20light%2C%20luxury%20red%20carpet%20atmosphere%20blurred%20in%20background%2C%20editorial%20fashion%20photography%2C%20refined%20warm%20tones&width=800&height=600&seq=yn-news-02&orientation=landscape",
    content: [
      "作为本届国际电影节受邀嘉宾，大岛优香出席了开幕式红毯环节。她身着一袭香槟色缎面长裙，配合简约的低盘发造型，整体气质优雅大方，与红毯的仪式感相得益彰。",
      "当晚，大岛优香在媒体区简短接受了采访。谈及此次参与电影节的感受，她坦言：「能在这样的场合和世界各地的电影人交流，是一件很幸福的事，也让我对表演有了新的期待。」",
      "电影节期间，大岛优香还参加了青年电影人论坛，与多位导演、编剧就「表演与真实」的话题展开对谈，分享了自己在角色准备阶段的方法与心得。",
      "据主办方统计，本届电影节共展映来自三十余个国家和地区的作品，大岛优香相关活动的现场照片也在社交平台获得大量转发，话题热度持续走高。",
    ],
  },
  {
    id: 3,
    title: "《逆光而行》正式杀青，大岛优香挑战全新角色类型",
    summary:
      "历经四个月的紧张拍摄，悬疑题材电影《逆光而行》宣布杀青。大岛优香在片中首次挑战心理层次复杂的角色，拍摄过程被主创称为「一次极限挑战」。",
    category: "最新动态",
    date: "2026-09-12",
    author: "本站编辑部",
    source: "大岛优香官方资讯",
    views: 9745,
    image:
      "https://readdy.ai/api/search-image?query=dramatic%20backlight%20silhouette%20atmosphere%20with%20deep%20amber%20and%20charcoal%20tones%2C%20moody%20haze%20and%20soft%20light%20rays%2C%20cinematic%20minimal%20abstract%20background%2C%20editorial%20film%20photography&width=800&height=600&seq=yn-news-03&orientation=landscape",
    content: [
      "电影《逆光而行》于近日正式宣布杀青，结束了为期四个月的拍摄周期。该片由知名导演执导，大岛优香在片中担纲女主角，饰演一位在真相与记忆之间不断追寻的调查者。",
      "据导演介绍，这个角色的情绪层次非常丰富，既有克制的冷静，也有崩溃边缘的脆弱。为了呈现真实的状态，大岛优香在拍摄期间进行了大量体能和心理层面的准备。",
      "「有一场戏我们连续拍了十几个小时，她始终保持在同一情绪里，没有一次走神。」制片人在采访中这样评价她的专业度。",
      "《逆光而行》目前进入后期制作阶段，预计明年登陆大银幕。片方表示，年内会释出首支预告，敬请期待。",
    ],
  },
  {
    id: 4,
    title: "大岛优香官宣加盟综艺《慢生活手记》，展现生活另一面",
    summary:
      "在最新一期节目官宣中，大岛优香确认加盟生活观察类综艺《慢生活手记》，她将在节目中走进山间小镇，用镜头记录最本真的日常。",
    category: "最新动态",
    date: "2026-09-05",
    author: "综艺观察",
    source: "节目官方账号",
    views: 15320,
    image:
      "https://readdy.ai/api/search-image?query=cozy%20countryside%20morning%20light%20over%20soft%20green%20hills%20and%20wooden%20table%20with%20ceramic%20teacup%2C%20warm%20neutral%20tones%2C%20lifestyle%20editorial%20photography%2C%20gentle%20and%20calm%20atmosphere&width=800&height=600&seq=yn-news-04&orientation=landscape",
    content: [
      "生活观察类综艺《慢生活手记》今日官宣新一季嘉宾阵容，大岛优香赫然在列。节目以「放下忙碌，重新生活」为理念，记录嘉宾在小镇中经营一间小院、料理三餐的真实过程。",
      "节目组释出的先导片段中，大岛优香系着围裙在院子里晾晒衣物、和邻居学习制作当地点心，状态松弛自然，与她在影视作品中的形象形成有趣反差。",
      "她本人在社交平台写道：「很久没有这样安静地过一个上午了。原来把时间交还给生活，是一件很温柔的事。」",
      "《慢生活手记》新一季将于本月底开播，每周更新一期，本站将持续为大家带来精彩片段与幕后花絮。",
    ],
  },
  {
    id: 5,
    title: "大岛优香荣获年度最佳女演员，台上感谢团队与粉丝",
    summary:
      "在年度影视盛典颁奖礼上，大岛优香凭借上一年的出色表现摘得「年度最佳女演员」奖项。发表感言时她数度哽咽，向团队与一路陪伴的粉丝致谢。",
    category: "娱乐新闻",
    date: "2026-08-27",
    author: "本站编辑部",
    source: "影视盛典官方",
    views: 24108,
    image:
      "https://readdy.ai/api/search-image?query=golden%20award%20trophy%20on%20dark%20stage%20with%20warm%20spotlight%20and%20sparkling%20bokeh%2C%20elegant%20ceremony%20atmosphere%2C%20deep%20amber%20highlights%2C%20premium%20editorial%20photography&width=800&height=600&seq=yn-news-05&orientation=landscape",
    content: [
      "在刚刚结束的年度影视盛典上，大岛优香凭借过去一年在多部作品中的稳定发挥，荣获「年度最佳女演员」大奖。当颁奖嘉宾念出她的名字时，全场响起长时间的掌声。",
      "登台后，大岛优香坦言自己完全没有准备这么长的感言。「我一直觉得表演是一件很私人的事，但今天站在这里才发现，其实有太多人和我一起完成了这些角色。」",
      "她特别感谢了合作过的导演、剧组伙伴，以及始终支持她的观众：「是你们的相信，让我敢于一次次走进不同的角色里。」",
      "本年度她还凭借该表现入围了多个专业奖项，业界普遍认为这是她演艺生涯中非常重要的一年。",
    ],
  },
  {
    id: 6,
    title: "新片《雾中灯塔》发布先导预告，悬疑气质拉满",
    summary:
      "电影《雾中灯塔》正式发布首支先导预告，冷峻的影像风格与层层递进的悬念引发网友热议，大岛优香在片中的表现成为讨论焦点。",
    category: "娱乐新闻",
    date: "2026-08-18",
    author: "影评人 陈舟",
    source: "片方官方发布",
    views: 18392,
    image:
      "https://readdy.ai/api/search-image?query=foggy%20coastal%20lighthouse%20at%20dusk%20with%20pale%20mist%20and%20muted%20slate%20blue%20tones%2C%20mysterious%20cinematic%20atmosphere%2C%20minimal%20abstract%20seascape%2C%20editorial%20film%20photography&width=800&height=600&seq=yn-news-06&orientation=landscape",
    content: [
      "悬疑电影《雾中灯塔》今日发布首支先导预告片，短短一分钟的画面中，浓雾、海岸与忽明忽暗的灯塔交替出现，节奏克制却张力十足。",
      "预告里，大岛优香的镜头虽不多，但一个回望的眼神被网友截图反复讨论，不少人评价她「用眼神演完了一整段故事」。",
      "据片方介绍，影片围绕一座海边小镇的旧案展开，大岛优香饰演的角色是解开谜团的关键人物，其真实动机将随着剧情层层揭开。",
      "《雾中灯塔》暂定于明年上半年上映，具体的定档信息将于后续陆续公布。",
    ],
  },
  {
    id: 7,
    title: "大岛优香公益项目启动，助力乡村儿童艺术教育",
    summary:
      "由大岛优香发起的艺术教育公益项目正式启动，项目计划为多所乡村学校建设艺术教室，并邀请专业老师开展长期支教课程。",
    category: "活动预告",
    date: "2026-08-06",
    author: "公益频道",
    source: "项目官方公告",
    views: 7654,
    image:
      "https://readdy.ai/api/search-image?query=colorful%20children%20art%20supplies%20paint%20brushes%20and%20sketchbooks%20on%20a%20light%20wooden%20table%2C%20warm%20sunlight%2C%20cheerful%20editorial%20photography%2C%20soft%20orange%20and%20cream%20tones%2C%20clean%20minimal%20background&width=800&height=600&seq=yn-news-07&orientation=landscape",
    content: [
      "由大岛优香发起并参与的艺术教育公益项目正式启动。项目首期计划为多所乡村学校改造并建设专门的艺术教室，同时配备绘画、手工等基础教学器材。",
      "除了硬件支持，项目还将邀请专业艺术老师开展长期支教课程，帮助孩子们建立对美的感知与表达。「每个孩子都值得拥有被看见的可能。」大岛优香在启动仪式上说。",
      "她本人也将在项目周期内定期前往学校，与孩子们一起上课、创作，把这段经历记录成影像作品，让更多人关注到乡村艺术教育的现状。",
      "项目详情与参与方式已在官方渠道公布，欢迎有意愿的朋友共同关注与支持。",
    ],
  },
  {
    id: 8,
    title: "大岛优香登上时尚杂志封面，演绎秋日复古风",
    summary:
      "在最新一期时尚杂志中，大岛优香登上封面人物，以一组充满复古电影感的秋日大片展现出与以往截然不同的时尚气质。",
    category: "娱乐新闻",
    date: "2026-07-30",
    author: "时尚频道",
    source: "杂志官方发布",
    views: 11209,
    image:
      "https://readdy.ai/api/search-image?query=autumn%20retro%20fashion%20still%20life%20with%20wool%20coat%20texture%20and%20dried%20flowers%2C%20warm%20taupe%20and%20russet%20tones%2C%20soft%20window%20light%2C%20editorial%20magazine%20photography%2C%20refined%20minimal%20composition&width=800&height=600&seq=yn-news-08&orientation=landscape",
    content: [
      "最新一期时尚杂志以「秋日的重新想象」为主题，邀请大岛优香担任封面人物。整组大片取景于一座老式公寓，暖调的光线与复古的着装共同营造出电影般的氛围。",
      "摄影师评价她「非常懂得如何在镜头前安静下来」，一个眼神、一次转身都自带故事感，这让整组拍摄变得高效而富有惊喜。",
      "在随刊采访中，大岛优香聊到了自己对时尚的理解：「我不是一个追逐潮流的人，我更在意一件衣服能不能让我觉得自在。」",
      "本期杂志已于近日发售，完整的封面故事与幕后花絮也可在杂志官方平台查阅。",
    ],
  },
];